import colors from 'vuetify/lib/util/colors'

let darkMode = false
if (typeof Storage !== 'undefined')
{ // eslint-disable-line
  darkMode = localStorage.getItem('luxiDarkMode') || false
}

const palette = {
  rose: {
    primary: colors.pink.base, // primary main
    primarylight: colors.pink.lighten4, // primary light
    primarydark: colors.pink.darken3, // primary dark
    secondary: colors.orange.base, // secondary main
    secondarylight: colors.orange.lighten4, // secondary light
    secondarydark: colors.deepOrange.darken4, // secondary dark
    accent: colors.cyan.base, // accent main
    accentlight: colors.cyan.lighten4, // accent light
    accentdark: colors.cyan.darken4, // accent dark
    anchor: colors.cyan.base // link
  },
  deepblue: {
    primary: colors.indigo.base, // primary main
    primarylight: colors.indigo.lighten5, // primary light
    primarydark: colors.indigo.darken3, // primary dark
    secondary: colors.red.base, // secondary main
    secondarylight: colors.red.lighten5, // secondary light
    secondarydark: colors.red.darken2, // secondary dark
    anchor: colors.indigo.base, // link
    accent: colors.indigo.accent4, // secondary main
    accentlight: colors.indigo.lighten4, // secondary light
    accentdark: colors.indigo.darken4 // secondary dark
  },
  money: {
    primary: colors.green.base, // primary main
    primarylight: colors.green.lighten4, // primary light
    primarydark: colors.green.darken3, // primary dark
    secondary: colors.amber.darken2, // secondary main
    secondarylight: colors.amber.lighten4, // secondary light
    secondarydark: colors.amber.darken4, // secondary dark
    accent: colors.blue.base, // secondary main
    accentlight: colors.blue.lighten4, // secondary light
    accentdark: colors.blue.darken4, // secondary dark
    anchor: colors.green.base // link
  },
  vampire: {
    primary: colors.red.base, // primary main
    primarylight: colors.red.lighten5, // primary light
    primarydark: colors.red.darken1, // primary dark
    secondary: colors.blueGrey.base, // secondary main
    secondarylight: colors.blueGrey.lighten5, // secondary light
    secondarydark: colors.blueGrey.darken2, // secondary dark
    anchor: colors.red.base, // link
    accent: colors.pink.base, // accent main
    accentlight: colors.pink.lighten4, // accent light
    accentdark: colors.pink.darken3, // accent dark
  },
}

export const theme = {
  ...palette.deepblue
}

export default {
  rtl: false,
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: darkMode === 'true',
    themes: {
      light: {
        ...theme
      },
      dark: {
        ...theme
      }
    },
    options: {
      customProperties: true
    }
  }
}
